import { render, staticRenderFns } from "./JgpTaskFlow.vue?vue&type=template&id=913bb74a&"
import script from "./JgpTaskFlow.vue?vue&type=script&lang=js&"
export * from "./JgpTaskFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports